import { RESET_AUTH, PURGE_AUTH, SET_TOKEN } from '../mutation-types';
import { LOGIN, LOGOUT } from '../action-types';
import AuthService from '@/services/AuthService';

// state
const localState = () => ({
  user: JSON.parse(localStorage.getItem('user') || '{}'),
  token: localStorage.getItem('token') || '',
  menu: AuthService.menu,
  currency: JSON.parse(localStorage.getItem('pos_currency') || '{"symbol": "฿"}'),
});

// getters
const localGetters = {
  getVisibleMenu: state => (can) => {
    const visibleMenu = [];
    state.menu.forEach(link => {
      if(link.permission) {
        if(can(link.permission)) {
          visibleMenu.push(link);
        }
      } else if(link.children) {
        let visible = false;
        const children = [];
        link.children.forEach(child => {
          if(child.permission && can(child.permission)) {
            visible = true;
            children.push(child);
          }
        });
        if(visible) {
          const cloneLink = Object.assign({}, link);
          cloneLink.children = children;
          visibleMenu.push(cloneLink);
        }
      }
    });
    return visibleMenu;
  },
};

// mutations
const mutations = {
  [RESET_AUTH](state) {
    Object.assign(state, localState());
  },

  [PURGE_AUTH](state) {
    state.user = {};
    state.token = '';

    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('lang');
    localStorage.removeItem('pos_currency');
  },

  [SET_TOKEN](state, { user, token, currency }) {
    state.user = user;
    state.token = token;
    state.currency = currency ? currency : {};
    localStorage.setItem('user', JSON.stringify(state.user));
    localStorage.setItem('token', state.token);
    localStorage.setItem('pos_currency', JSON.stringify(state.currency));
  },
};

// actions
const actions = {
  [LOGIN](state, input) {
    AuthService.login(input);
  },

  [LOGOUT]({ commit }) {
    commit(PURGE_AUTH);
  },
};

export default {
  state: localState(),
  getters: localGetters,
  mutations,
  actions,
};
